export const SET = 'company/SET';
export const CLEAR = 'company/CLEAR';
